module.exports = __webpack_public_path__ + "static/img/logo-all.29b63bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/logo-all.png
// module id = iQFH
// module chunks = 1